import moment from 'moment-timezone';

// Formatea cualquier valor de fecha reconocible por moment a DD/MM/YYYY para las tablas
export const formatDateDDMMYYYY = (value) => {
  if (!value) return '-';
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value;
};
